import { FormularModelMetaWartungsStateSchema, FormularModelMetaWartungsStatesSchema } from "./WartungsState";
import { FormularModelMetaMaterialActionNamesSchema, FormularModelMetaMaterialActionSchema } from "./MaterialActionNames";
import { FormularModelMetaProtocolsSchema } from "./Protocols";
import { FormularModelMetaCompanyDataSchema } from "./CompanyData";
import { CommonKeys } from "../../../common/enums";
import { FORMULAR_MODEL_META_TYPE } from "../../../common/formular-group-types";

export const FormularModelMetaSchema = {
    $id: "FormularModelMetaSchema",
    title: "FormularModelMeta Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_MODEL_META_TYPE },
        [CommonKeys.ShowLegend]: { type: "boolean" },
        CompanyData: { $ref: "FormularModelMetaCompanyDataSchema" },
        WartungsStates: {
            oneOf: [
                { $ref: "FormularModelMetaWartungsStatesSchema" },
                { type: "null" }
            ]
        },
        MaterialActionNames: {
            oneOf: [
                { $ref: "FormularModelMetaMaterialActionNamesSchema" },
                { type: "null" }
            ]
        },
        Protocols: {
            oneOf: [
                { $ref: "FormularModelMetaProtocolsSchema" },
                { type: "null" }
            ]
        }
    },
    required: [CommonKeys.Type, CommonKeys.ShowLegend, "WartungsStates", "CompanyData", "MaterialActionNames", "Protocols"]
}

export const FORMULAR_META_SCHEMAS = [
    FormularModelMetaSchema,
    FormularModelMetaCompanyDataSchema,
    FormularModelMetaMaterialActionNamesSchema,
    FormularModelMetaMaterialActionSchema,
    FormularModelMetaProtocolsSchema,
    FormularModelMetaWartungsStateSchema,
    FormularModelMetaWartungsStatesSchema
]